import { render, staticRenderFns } from "./CompanyIntroduct.vue?vue&type=template&id=00cc90dc&scoped=true"
import script from "./CompanyIntroduct.vue?vue&type=script&lang=js"
export * from "./CompanyIntroduct.vue?vue&type=script&lang=js"
import style0 from "./CompanyIntroduct.vue?vue&type=style&index=0&id=00cc90dc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00cc90dc",
  null
  
)

export default component.exports